import React from 'react';
import DatePicker from "react-datepicker";
import Header from '../../ComponentsNav/Header';
import Footer from '../../ComponentsNav/Footer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileExcel } from '@fortawesome/free-solid-svg-icons'
import './index.css';
import MenuFlotanteSoporte from '../../ComponentsNav/MenuFlotanteSoporte';

const fechaInicio = new Date();
let fechaFin = new Date();
fechaInicio.setDate(fechaInicio.getDate() -1);

class Reporte extends React.Component {
    
    constructor(props) {
        super(props);

        this.state = {
            tipoConsulta: "1",
            fechaInicio: fechaInicio,
            fechaFin: fechaFin,
            nombreArchivo: '',
            conteo: false,
            idMarca: "-1",
            csvFile: <div></div>,
            totalResult: <div></div>,
            cargando: false,
            inicio: true
        };
    }

    componentDidMount(){
        var self = this;
        self.setState({cargando: true});
        fetch(process.env.REACT_APP_ESTADOS_KMI_JSON)
        .then(function(response) {
            return response.text();
        })
        .then(function(data) {
            var parsedData = JSON.parse(data);
            var estadosArray = parsedData.filter(x => x.name === process.env.REACT_APP_AMBIENTE);
            var estados = [];
            for(var i=0; i<estadosArray[0].estados.length; i++){
                estados.push(estadosArray[0].estados[i].idEstado);
            }
            self.setState({checkboxes: self.createCheckboxes(estadosArray[0].estados), estados: estados, cargando: false});
        })
        .catch(function(err) {
            console.error(err);
            self.setState({cargando: false});
        });
    }
    
    createCheckboxes = estados => {
        const checkboxes = estados.map((item) =>
            <div className="form-check" key={item.idEstado}>
                <input className="form-check-input" type="checkbox" value={item.idEstado} id={item.idEstado} defaultChecked={item.checked} onChange={this.modificaEstado}></input>
                <label className="form-check-label" htmlFor={item.idEstado}>{item.estado}</label>
            </div>
        );        
        return checkboxes;
    }

    createCsvFileLink = link => {
        return <a href={link}><FontAwesomeIcon href={link} icon={faFileExcel} size="3x" /></a>
    }

    createTotalResult = total => {
        return <p><span  className="font-weight-bold">Total: </span>{total}</p>
    }

    cambiaTipoConsulta = event => {
        this.setState({ tipoConsulta: event.target.value, jsonResults: <div></div> });
    }

    cambiaFechaInicio = value => {
        this.setState({
            fechaInicio: value
        });
    }

    cambiaFechaFin = value => {
        this.setState({
            fechaFin: value
        });
    }

    cambiaMarca = event => {
        this.limpiaErrorAcceso();
        this.setState({
            idMarca: event.target.value,
            nombreArchivo: event.target.options[event.target.options.selectedIndex].outerText + ".csv"
        });
    }

    modificaEstado = event => {
        var estados = this.state.estados;
        if(event.target.checked){
            estados.push(parseInt(event.target.id));
            this.setState({estados: estados});
        } else {
            var index = estados.indexOf(parseInt(event.target.id));
            estados.splice(index, 1);
            this.setState({estados: estados});
        }
    }

    modificaTipoResultado = event => {
        if(event.target.id === "conteo"){
            this.setState({conteo: true});
        } else {
            this.setState({conteo: false});
        }
    }

    limpiaErrorAcceso = () => {
        this.setState({ errorMarca: '' })
    }

    getDate = (date) => {
        var month = date.getMonth() + 1;
        return date.getFullYear() + "-" + month.toString().padStart(2, "0") + "-" + date.getDate().toString().padStart(2, "0") + " " + date.getHours().toString().padStart(2, "0") +":"+date.getMinutes().toString().padStart(2, "0")+":00";
    }

    modificaSesion = event => {
        this.setState({inicio: event.target.checked});
      }

    consulta = event => {
        event.preventDefault();
        this.setState({csvFile: <div></div>, totalResult: <div></div>});
        var error = false;
        var params = {};
        params.marca = this.state.idMarca;
        params.horaRegistro = this.getDate(this.state.fechaInicio);
        params.horaRegistroFin = this.getDate(this.state.fechaFin);
        params.estados = this.state.estados;
        params.conteo = this.state.conteo;
        params.inicio = this.state.inicio;
        
        let url_path = "reporte/cliente";

        if (this.state.tipoConsulta === "2") {
            url_path = "reporte/compras";
        }

        if (this.state.tipoConsulta === "3") {
            url_path = "reporte/notificaciones";
        }


        var self = this;
        if(!error) {
            self.setState({cargando: true});
            var queryString = Object.keys(params).map(key => key + '=' + params[key]).join('&');
            fetch(process.env.REACT_APP_URL_DTO_BACK + url_path + "?" + queryString, {
                method: "GET",
                headers: {
                    "Authorization": "Bearer " + this.props.servicio.getToken(),
                    "Content-Type": "application/json"
                }
            }).then(async res => {
                let responseBody = await res.json();
                        if(responseBody.mensaje.archivo !== undefined){
                            window.open(process.env.REACT_APP_URL_REPORTE + responseBody.mensaje.archivo, "_blank");
                            self.setState({cargando: false});
                        } else {
                            self.setState({csvFile: <div></div>, totalResult: self.createTotalResult(responseBody.mensaje[0].total), cargando: false});
                        }

                
            }).catch(errorP => {
                self.setState({cargando: false});
                console.log("errorResultado",errorP);
            });

        }
    }

    render(){
        return(
            <React.Fragment>
            <div className="container__font--vw">
                <Header></Header>
                <div className="container-fluid form__container--sup">
                    <form className=" container">
                        <div className="form__container">
                            <div className="form col-12">
                                <div className="row">
                                    <div className="col-12">
                                        <h3 className="title_form font-weight-bold mt-2 mb-3">Completa los datos solicitados:</h3>
                                    </div>
                                    <div className="col-sm-6 col-lg-6 col-xl-6 pt-4">
                                        <div className="form-group">
                                            <h5>Tipo de Consulta</h5>
                                            <select className="form-control" id="tipoConsulta" value={this.state.tipoConsulta} onChange={this.cambiaTipoConsulta}>
                                                <option value="1">Cliente</option>
                                                <option value="2">Compra</option>
                                                <option value="3">Notificaciones</option>
                                            </select>
                                        </div>

                                        <div className="form-group">
                                            <h5 htmlFor="acceso">Marcas</h5>
                                            <select className="form-control" id="acceso" value={this.state.idMarca} onChange={this.cambiaMarca}>
                                                <option value="-1">Todos las marcas</option>
                                                <option value="1">VW Pasajeros</option>
                                                <option value="2">VW Comerciales</option>
                                                <option value="3">Seat</option>
                                                <option value="4">Audi</option>
                                            </select>
                                            <div className="text-danger">{this.state.errorMarca}</div>
                                        </div>

                                        <div className="form-group">
                                            <h5 htmlFor="fechaInicio">Fecha Inicio</h5>
                                            <DatePicker className="form-control" showTimeSelect selected={this.state.fechaInicio} onChange={this.cambiaFechaInicio}  dateFormat="MMMM d, yyyy h:mm aa"/>
                                        </div>

                                        <div className="form-group">
                                            <h5 htmlFor="fechaFin">Fecha Fin</h5>
                                            <DatePicker className="form-control" showTimeSelect selected={this.state.fechaFin} onChange={this.cambiaFechaFin}  dateFormat="MMMM d, yyyy h:mm aa"/>
                                        </div>

                                        <div className="row">
                                            <div className="col-6">
                                                <div className="form-group">
                                                    <h5 className="mb-3">Etapas</h5>
                                                    {this.state.checkboxes}
                                                </div>
                                            </div>
                                            <div className="col-6">
                                                <div className="form-group">
                                                    <h5 className="mb-3">Resultado</h5>
                                                    <div className="form-check">
                                                        <input className="form-check-input" type="radio" value="1" name="tipoResultado" id="conteo" onChange={this.modificaTipoResultado}></input>
                                                        <label className="form-check-label" htmlFor="conteo">Conteo</label>
                                                    </div>
                                                    <div className="form-check">
                                                        <input className="form-check-input" type="radio" value="1" name="tipoResultado" id="resultado" defaultChecked="true" onChange={this.modificaTipoResultado}></input>
                                                        <label className="form-check-label" htmlFor="conteo">Reporte</label>
                                                    </div>
                                                </div>

                                                <div className="form-group">
                                                    <h5 className="mb-3">Inicio sesion</h5>
                                                    <div className="form-check">
                                                        <input className="form-check-input" type="checkbox" value="1" name="inicioSesion" id="inicio" onChange={this.modificaSesion}></input>
                                                        <label className="form-check-label" htmlFor="inicio">Inicio sesion cliente</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <div className="text-center">
                                            <button className={"form__button form__button-white"} name="recuperar" onClick={this.consulta}><span className="small my-auto">Enviar</span></button>
                                        </div>

                                    </div>
                                    <div className="jsonResults col-sm-6 col-lg-6 col-xl-6 pt-4 overflow-auto">
                                        {this.state.jsonResults}
                                        {this.state.csvFile}
                                        {this.state.totalResult}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                <div className={"page__cargando" + (this.state.cargando ? " d-block" : " d-none")}></div>
                <MenuFlotanteSoporte servicio={this.props.servicio}></MenuFlotanteSoporte>
                <Footer marca={this.props.marca}></Footer>
            </div>
            </React.Fragment>
        );
    };
}

export default Reporte;